import './header-search.scss';

document.addEventListener('DOMContentLoaded', function() {
	const searchButton = document.querySelector('.header-search-button');
	const searchPopup = document.getElementById('header-search-pop');
	const searchInput = searchPopup.querySelector('input[type="text"]');

	// Function to toggle search popup
	function toggleSearch(event) {
		event.preventDefault();
		const isActive = searchPopup.classList.contains('is-active');

		// Toggle visual state
		searchPopup.classList.toggle('is-active');

		// Toggle ARIA states
		searchButton.setAttribute('aria-expanded', !isActive);
		searchPopup.setAttribute('aria-hidden', isActive);

		// If search becomes active, focus on the input field
		if (!isActive) {
			setTimeout(() => {
				searchInput.focus();
			}, 10);
		} else {
			// Return focus to the button when closing
			searchButton.focus();
		}
	}

	// Close search when clicking outside
	function closeSearchOnClickOutside(event) {
		if (searchPopup.classList.contains('is-active') &&
			!searchPopup.contains(event.target) &&
			!searchButton.contains(event.target)) {

			// Update visual state
			searchPopup.classList.remove('is-active');

			// Update ARIA states
			searchButton.setAttribute('aria-expanded', 'false');
			searchPopup.setAttribute('aria-hidden', 'true');

			// Return focus to the button
			searchButton.focus();
		}
	}

	// Add keyboard support for the search button (Enter and Space)
	searchButton.addEventListener('keydown', function(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault(); // Prevent scrolling on Space
			toggleSearch(event);
		}
	});

	// Event Listeners
	searchButton.addEventListener('click', toggleSearch);
	document.addEventListener('click', closeSearchOnClickOutside);

	// Close on escape key
	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && searchPopup.classList.contains('is-active')) {
			// Update visual state
			searchPopup.classList.remove('is-active');

			// Update ARIA states
			searchButton.setAttribute('aria-expanded', 'false');
			searchPopup.setAttribute('aria-hidden', 'true');

			// Return focus to the button
			searchButton.focus();
		}
	});
});